var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#232428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6066 19.0733L9.88751 22.1367L7 22.1367L10.1766 16.4758L7.02712 10.8633L9.91463 10.8633L11.585 13.8946L11.6054 13.9297L13.3604 10.8022L16.2479 10.8022L13.0725 16.4609L13.0775 16.4694L16.275 22.1978H13.3875L11.6242 19.1053L11.6066 19.0733ZM19.5122 12.4735L17.6129 10.8022H21.4115V14.6007H19.5122V12.4735ZM22.1712 10.8022L24.0705 12.4735V14.6007H25.9697V10.8022H22.1712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX11);
export default __webpack_public_path__ + "static/media/x11.1d498a3f313000e84d34a183d5c5ddef.svg";
export { ForwardRef as ReactComponent };